import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'thead'>

/**
 * 基本的なTheadコンポーネント
 */
export const BasicThead: FC<Props> = ({ children, ...props }) => {
  return <thead {...props}>{children}</thead>
}
